export default "__VITE_ASSET__9XfxRsUM__"